/// <amd-module name="Build/DesignerExtensions/ExclusiveLockCheckPanel/Components/ExclusiveLockCheckComponent" />
import * as React from "react";

import { IVssComponentProperties, VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";
import * as PipelineChecksContracts from "Checks/Client/Contracts/PipelinesChecks";
import { CheckAction } from "Checks/Client/Contracts/Contracts";
import * as Constants from "Build/DesignerExtensions/ExclusiveLockCheckPanel/Constants";
import { ControlOptions } from "Build/DesignerExtensions/ExclusiveLockCheckPanel/Components/ControlOptions";
import * as Resources from "Build/DesignerExtensions/ExclusiveLockCheckPanel/Resources";

export interface IProps extends IVssComponentProperties {
    resource: PipelineChecksContracts.Resource;
    timeout: number;
    checkAction: CheckAction;
    updateCheckDataAndEnableSave: (check: PipelineChecksContracts.CheckConfiguration) => void;
    updateTelemetryData: (telemetryData: { [key: string ]: string }) => void;
    disableCreateButton: (value: boolean) => void;
}

export class ExclusiveLockCheckComponent extends VssComponent<IProps, {}>{

    public constructor(props: IProps, context: IVssComponentContext) {
        super(props, context);
    }

    public componentDidMount(): void {
        super.componentDidMount();

        this._timeoutInMinutes = this.props.timeout;
        this._updateCheckState();
        this.props.disableCreateButton(false);
    }

    public render(): JSX.Element {
        return (
            <div className="check-panel-content">
                <div className="margin-vertical-8 padding-horizontal-20">
                    <MessageCard severity={MessageCardSeverity.Warning}>
                        <span className="multiline-error">{Resources.ConfigPanelDescription}</span>
                    </MessageCard>
                </div>
                <ControlOptions
                    timeout={this.props.timeout}
                    onUpdateTimeout={this._onTimeoutUpdate}
                    setControlOptionsValidity={this._setControlOptionsValidity} />
            </div>
        );
    }

    private _hasTimeoutModified(): boolean {
        return this.props.timeout !== this._timeoutInMinutes;
    }

    private _isCheckInvalid(): boolean {
        return !this._areControlOptionsValid;
    }

    private _updateCheckState = (): void => {
        const isCheckModified = this._hasTimeoutModified();
        const shouldDisableCreateButton = this._isCheckInvalid() || !(this.props.checkAction === CheckAction.Edit ? isCheckModified : true);
        if (shouldDisableCreateButton) {
            this.props.disableCreateButton(shouldDisableCreateButton);
        }
        else {
            const record = {
                type: {
                    id: Constants.ExclusiveLockPolicyTypeIdString,
                    name: Constants.ExclusiveLockPolicyTypeName
                },
                settings: {},
                resource: this.props.resource,
                timeout: this._timeoutInMinutes
            } as PipelineChecksContracts.GenericCheckConfiguration;
            this.props.updateCheckDataAndEnableSave(record);
            this.props.updateTelemetryData(this._getTelemetryData());
        }
    }

    private _getTelemetryData = (): { [key: string]: string } => {
        return {
            CheckType: Constants.ExclusiveLockPolicyTypeName,
            Timeout: this._timeoutInMinutes.toString()
        };
    }

    private _onTimeoutUpdate = (timeout: number): void => {
        this._timeoutInMinutes = timeout;
        this._updateCheckState();
    }

    private _setControlOptionsValidity = (isTimeoutValid: boolean): void => {
        this._areControlOptionsValid = isTimeoutValid;
        this._updateCheckState();
    }

    private _timeoutInMinutes: number;
    private _areControlOptionsValid: boolean;
}
